import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  getSuppliers,
  getSuppliersListTableData,
  getSupplierStatisticsData,
  getSupplierTableData,
} from './suppliers.async'

const initialState = {
  suppliersLoader: false,
  suppliersData: [],
  supplierStatisticsLoader: false,
  supplierStatisticsData: {},
  suppliersTableLoader: false,
  suppliersTableData: [],
  suppliersListTableLoader: false,
  suppliersListTableData: [],
}

const SuppliersReducer = createSlice({
  name: 'SuppliersReducer',
  initialState,
  reducers: {
    emptySuppliersReducer: (state) => {
      state.suppliersData = []
      state.supplierStatisticsData = {}
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSuppliers.pending), (state) => {
      state.suppliersLoader = true
    })
    builder.addMatcher(isAnyOf(getSuppliers.fulfilled), (state, action) => {
      state.suppliersLoader = false
      state.suppliersData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSuppliers.rejected), (state) => {
      state.suppliersLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierStatisticsData.pending), (state) => {
      state.supplierStatisticsLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierStatisticsData.fulfilled), (state, action) => {
      state.supplierStatisticsLoader = false
      state.supplierStatisticsData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierStatisticsData.rejected), (state) => {
      state.supplierStatisticsLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierTableData.pending), (state) => {
      state.suppliersTableLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierTableData.fulfilled), (state, action) => {
      state.suppliersTableLoader = false
      state.suppliersTableData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierTableData.rejected), (state) => {
      state.suppliersTableLoader = false
    })

    builder.addMatcher(isAnyOf(getSuppliersListTableData.pending), (state) => {
      state.suppliersListTableLoader = true
    })
    builder.addMatcher(isAnyOf(getSuppliersListTableData.fulfilled), (state, action) => {
      state.suppliersListTableLoader = false
      state.suppliersListTableData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSuppliersListTableData.rejected), (state) => {
      state.suppliersListTableLoader = false
    })
  },
})

export const { emptySuppliersReducer } = SuppliersReducer.actions
export default SuppliersReducer.reducer
